<template>
  <main class="container-fluid flex-grow-1 d-flex bg-lighter">
    <div class="row flex-grow-1">
      <navbar />
      
      <div class="col px-4 content-col">
        <breadcrumb />

        <section :class="['bg-white rounded mb-4 p-3', { 'p-sm-4': !noSmPadding }]">
          <slot name="heading"></slot>
          <slot name="content"></slot>
        </section>
      </div>
    </div>
  </main>
</template>

<script>
/* This is a consistent layout that should be used for listing pages.
 * Content will be added to the "slot" tags above automagically when
 * this component is added */

import navbar from '@/components/NavbarSide'
import breadcrumb from '@/components/Breadcrumb'

export default {
  name: 'Listing-Layout',
  props: {
    noSmPadding: {
      type: Boolean,
      default: false
    }
  },
  components: {
    navbar,
    breadcrumb
  }
}
</script>

<style scoped>
/* Bootstrap's `.col` is a flex item of `.row` (next to the side nav) with the default
   `min-width: auto`, so it refuses to shrink below its widest descendant's min-content —
   e.g. a ResponsiveTable's desktop grid-column tracks. That content then just forces this
   whole column (and the page) wider than the viewport instead of narrowing, which in turn
   means a container-width-driven component (ResponsiveTable's ResizeObserver) never sees
   a narrow enough width to switch to its mobile/accordion layout. `min-width: 0` lets the
   flexbox math shrink the column properly; `max-width: 100vw` is a hard ceiling on top of
   that for the same reason — confirmed fixing it where `min-width: 0` alone did not. It
   never binds at a width `.row`'s own flex distribution wouldn't already produce, so it
   doesn't need to be scoped to the side nav's own breakpoints. */
.content-col {
  min-width: 0;
  max-width: 100vw;
}
</style>



// WEBPACK FOOTER //
// src/components/ListingLayout.vue